import { TranslationKeys } from '../english/business-occupancy.i18n';

export const keys: TranslationKeys = {
  businessOccupancy: {
    businessTypes: {
      title: 'Quelles types d’entreprises opèrent dans l’immeuble ?',
      choices: {
        restaurant: 'Restaurant, bar, café ou pub',
        store: 'Magasin (ex. : vêtements, librairie, électronique)',
        office: 'Bureau (ex. : agence de voyage, agence immobilière)',
        gasStation: 'Station-service ou garage de réparation automobile',
        hazardousMaterialsHandler: 'Entreprise manipulant des matières dangereuses',
        other: 'Autre',
      },
    },
  },
};

export default keys;
